export const WALL_START_CHARGE_MS_OPTIONS = [0, 1000, 3000] as const;

export type WallStartChargeMs = (typeof WALL_START_CHARGE_MS_OPTIONS)[number];

export const DEFAULT_WALL_START_CHARGE_MS: WallStartChargeMs = 3000;

export function isWallStartChargeMs(
  value: unknown,
): value is WallStartChargeMs {
  return WALL_START_CHARGE_MS_OPTIONS.includes(value as WallStartChargeMs);
}
